import { useCallback } from 'react';
import './index.less';
import cN from 'classnames';
import { useCreateAccountProvider } from '@/lib/context';
import RightGrayIcon from '@/components/Common/Icons/RightGrayIcon';
import Image from 'next/image';
import { useIsMobileURL } from '@/shared/hooks';

const ActionCards = () => {
  const isMobile = useIsMobileURL();
  const { showSignupDialogFromSourcing } = useCreateAccountProvider();

  const handleClick = useCallback(
    (utm: string) => {
      showSignupDialogFromSourcing('', '', utm);
    },
    [showSignupDialogFromSourcing],
  );

  return (
    <>
      <div className={cN('action-cards', { 'action-cards-mobile': isMobile })}>
        <div className="card ideas-card" onClick={() => handleClick('get-design-ideas')}>
          <div className="icon">
            <Image
              width={32}
              height={32}
              alt={'icon'}
              src="https://static.pietrastudio.com/public/file_uploads/859c23d7671966f1faeca50c66e354a2.png"
              loading="lazy"
            />
            {isMobile && <span className="title">Get design ideas</span>}
            {isMobile ? <RightGrayIcon fill="#526EB2" /> : <RightGrayIcon />}
          </div>
          {!isMobile && (
            <>
              <div className="title">
                <span>Get design ideas</span>
                <RightGrayIcon />
              </div>
              <div className="body">Use AI to create variations of this product and send to this factory.</div>
            </>
          )}
        </div>
        <div className="card intercom-card talk-to-specialist-action" onClick={() => handleClick('get-help')}>
          <div className="icon">
            <Image
              width={32}
              height={32}
              alt="help"
              src="https://static.pietrastudio.com/public/file_uploads/f98dda6ff5e6d8c21f1cf59798286b00.png"
              loading="lazy"
            />
            {isMobile && <span className="title">Get help</span>}
            {isMobile ? <RightGrayIcon fill="#57AD6A" /> : <RightGrayIcon />}
          </div>
          {!isMobile && (
            <>
              <div className="title">
                <span>Get help from a pro</span>
                <RightGrayIcon />
              </div>
              <div className="body">Ask a Pietra pro how to decide if you want to work with a factory</div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ActionCards;
